import { render, staticRenderFns } from "./tuikuan.vue?vue&type=template&id=dd9511dc&scoped=true&"
import script from "./tuikuan.vue?vue&type=script&lang=js&"
export * from "./tuikuan.vue?vue&type=script&lang=js&"
import style0 from "./tuikuan.vue?vue&type=style&index=0&id=dd9511dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9511dc",
  null
  
)

export default component.exports